module.exports = __webpack_public_path__ + "quotezone-ui/img/seopa-provided.9290977d.svg";